import { provideAppInitializer, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CommonModule } from '@angular/common';
import { SharedModule } from './shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GoogleMapsModule } from '@angular/google-maps';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule,provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { StoreModule, MetaReducer } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { appReducer } from './store/app.state';
import { hydrationMetaReducer, clearState } from './auth/state/hydration.reducer';
import { AuthorizationInterceptor } from './interceptors/authorization.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { SentryErrorHandler } from './sentry/sentry-error-handler';
import {
  NgcCookieConsentModule,
  NgcCookieConsentConfig,
} from 'ngx-cookieconsent';
import { BidiModule } from '@angular/cdk/bidi';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAnalyticsModule, ScreenTrackingService, UserTrackingService } 
        from '@angular/fire/compat/analytics';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { TransactionProcessingComponent } from './click-it/create-order/cement/payment/transaction-processing/transaction-processing.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/translations/', '.json');
}

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: window.location.hostname,
    secure: true,
  },
  position: 'bottom-right',
  palette: {
    popup: {
      background: '#002148',
    },
    button: {
      background: '#ffffff',
      text: '#002148',
    },
  },
  theme: 'classic',
  type: 'opt-out',
};

const providersArray = false
  ? [
      TranslateService,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthorizationInterceptor,
        multi: true,
      },
      {
        provide: ErrorHandler,
        useClass: SentryErrorHandler,
      },
      ScreenTrackingService,
      UserTrackingService,
      provideAppInitializer(() => initializeAnalytics()())
      
    ]
  : [
      TranslateService,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthorizationInterceptor,
        multi: true,
      },
      ScreenTrackingService,
      UserTrackingService,
      provideAppInitializer(() => initializeAnalytics()())
    ];

const metaReducers: MetaReducer[] = [hydrationMetaReducer, clearState];

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export function initializeAnalytics(): () => void {
  return () => {
    console.log("INITIALIZE");
    
    const gtagScript = document.createElement('script');
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.firebase.measurementId}`;
    gtagScript.async = true;
    document.head.appendChild(gtagScript);

    window['dataLayer'] = window['dataLayer'] || [];
    window.gtag = function() { window.dataLayer.push(arguments); };

    window.gtag('js', new Date());
    window.gtag('config', environment.firebase.measurementId, {
      cookie_flags: 'SameSite=Strict;Secure',
    });
  };
}

@NgModule({
  declarations: [AppComponent, TransactionProcessingComponent],
  imports: [
    CommonModule,
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    AngularFireMessagingModule,
    StoreModule.forRoot(appReducer, { metaReducers }),
    StoreDevtoolsModule.instrument({ logOnly: environment.production }),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),

    GoogleMapsModule,
    BidiModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  exports: [TranslateModule, GoogleMapsModule, BidiModule],
  providers: [...providersArray,provideHttpClient(withInterceptorsFromDi())],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(){
    console.log("TESTAPP");
    
  }
}
